import React from 'react';
import Hero from '../components/Hero';
import FlightBooking from '../components/FlightBooking';
import Introduction from '../components/Introduction';
import Activities from '../components/Activities';
import MediaSection from '../components/MediaSection';
import BecomePilot from '../components/BecomePilot';
import Training from '../components/Training';
import Airfield from '../components/Airfield';
import Aircraft from '../components/Aircraft';
import Events from '../components/Events';
import Contact from '../components/Contact';
import StructuredData, { homeStructuredData } from '../components/StructuredData';
import { usePageMeta } from '../hooks/usePageMeta';
import site from '../data/site.json';

const minPrice = Math.min(...site.packages.map((pkg) => pkg.price));

const HomePage: React.FC = () => {
  usePageMeta({
    title: 'Flugsportverein Otto Lilienthal Bad Langensalza | Rundflüge & Flugausbildung',
    description: `Rundflüge ab ${minPrice} €, Segelflug und Ultraleichtflug sowie Ausbildung (GPL, SPL) am Flugplatz Bad Langensalza (EDEB) vor den Toren des Nationalparks Hainich.`,
    path: '/',
  });

  return (
    <>
      <StructuredData data={homeStructuredData} />
      <Hero />
      <FlightBooking />
      <Introduction />
      <Activities />
      <MediaSection />
      <BecomePilot />
      <Training />
      <Aircraft />
      <Airfield />
      {/* Mobil untereinander, am Desktop Veranstaltungen und Kontakt nebeneinander */}
      <div className="lg:mx-auto lg:grid lg:max-w-screen-xl lg:grid-cols-2 lg:gap-16 lg:px-12 lg:py-[72px]">
        <Events />
        <Contact />
      </div>
    </>
  );
};

export default HomePage;
